<template>
  <div class="application-table-similars-dropdown">
    <el-dropdown
      v-if="application.similar_applications"
      placement="bottom-start"
      size="mini"
      split-button
      type="primary">
    Похожие заявления
    <el-dropdown-menu slot="dropdown" class="application-table-similars-dropdown-popup">
      <el-dropdown-item v-for="(similar_application, i) in application.similar_applications" :key="i">
        <router-link :to="{name: 'application',params: {id: similar_application.id}}" target="_blank">
          #{{similar_application.id}}| {{similar_application.repr}}
        </router-link>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
  </div>
</template>
<script>
//opens similar applications
export default {
  props: {
    application: {
      required: true,
      type: Object
    }
  }
}
</script>